var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1895 1.47363H12.5895C8.49676 1.47363 5.17896 4.79144 5.17896 8.88416V31.1158C5.17896 35.2085 8.49676 38.5263 12.5895 38.5263H30.1895C34.2822 38.5263 37.6 35.2085 37.6 31.1158V8.88416C37.6 4.79144 34.2822 1.47363 30.1895 1.47363Z",
    stroke: "#333333",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3878 23.2237C16.2225 24.0055 13.1693 25.5987 15.0294 27.5922C15.9372 28.5666 16.9505 29.2632 18.2214 29.2632H25.4838C26.7547 29.2632 27.7681 28.5666 28.6759 27.5922C30.5359 25.5987 27.4828 24.0055 26.3175 23.2255C25.0003 22.3311 23.4448 21.8529 21.8526 21.8529C20.2604 21.8529 18.705 22.3311 17.3878 23.2255M7.03155 8.88428H2.39996M7.03155 20.0001H2.39996M7.03155 31.1159H2.39996M25.5579 14.4422C25.5579 15.4249 25.1675 16.3673 24.4726 17.0622C23.7778 17.7571 22.8353 18.1474 21.8526 18.1474C20.8699 18.1474 19.9275 17.7571 19.2326 17.0622C18.5377 16.3673 18.1473 15.4249 18.1473 14.4422C18.1473 13.4595 18.5377 12.517 19.2326 11.8222C19.9275 11.1273 20.8699 10.7369 21.8526 10.7369C22.8353 10.7369 23.7778 11.1273 24.4726 11.8222C25.1675 12.517 25.5579 13.4595 25.5579 14.4422Z",
    stroke: "#333333",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.7b9923c9f191f031975e21dd4d306c52.svg";
export { ForwardRef as ReactComponent };